module.exports = __webpack_public_path__ + "img/bg-image.efa36ef0.jpg";